import React, { useEffect, useState, useRef } from 'react';
import EventToolboxComponent from '../../components/eventToolbox/EventToolbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    PageContentWrapper,
    LeftTopWrapper,
    LeftContentWrapper,
    RightContentWrapper,
    LastUpdated,
    LeftBottomWrapper,
    EventWrapper,
    HeadingWrapper,
    HeadingOuterWrapper,
    DeleteEventsWrapper,
    DeleteTextWrapper,
    DeleteButtonsWrapper,
    RightWrapper,
    TitleOuterWrapper,
    LeftHeadingWrapper,
    RightHeadingWrapper,
    DetailsCheckboxWrapper,
    DetailsText,
} from './ReportEvents.styles';
import { PlainTextButton, PrinterButton } from '../../styles/button.style';
import { useRotationStore } from '../../context/RotationContext';
import RotationTree from '../../components/rotation-tree/RotationTree';
import { useEventStore } from '../../context/EventContext';
import ReportedEventsList from '../../components/events/reported-events-list/ReportedEventsList';
import { useEventTypeStore } from '../../context/EventTypeContext';
import { EventInputWrapper } from '../../components/eventToolbox/EventToolbox.styles';
import EventInputComponent from '../../components/eventInput/EventInput';
import ReportingContextInfo from '../../components/events/ReportingContextInfo';
import { ExpandPanelButton, SortButton, TrashButton, EllipsisVerticalButton, ExitButton } from '../../styles/button.style';
import { RotationTreeEnum } from '../../enums/rotationTreeEnum';
import useDeleteTankersEvent from '../../api/useDeleteTankersEvent';
import { useVesselStore } from '../../context/VesselContext';
import useRotation from '../../app/useRotation';
import { IRotationNode } from '../../types/ViewModel/IRotationNode';
import useEvent from '../../app/useEvent';
import useEventType from '../../app/useEventType';
import queryParamsUtils from '../../utils/queryParamsUtils';
import { PortCall } from '../../types/ViewModel/PortCall';
import useGetTankersEventForVoyage from '../../api/useGetTankersEventForVoyage';
import useGetRotation from '../../api/useGetRotation';
import eventMoveUtils from '../../utils/event/eventMoveUtils';
import eventtypehandler from '../../utils/event/eventtypehandler';
import TankersEventFactory from '../../factory/TankersEventFactory';
import { Rotation } from '../../types/ViewModel/Rotation';
import { TankersEvent } from '../../types/ViewModel/TankersEvent';
import RotationFactory from '../../factory/ReportEvents/Rotation/RotationFactory';
import { useAuthStore } from '../../context/AuthContext';
import RetroactiveCargoModeToggle from '../../components/eventInput/retroactive-cargo-mode-toggle/RetroactiveCargoModeToggle';
import PrinterPanel from '../../components/printer-panel/PrinterPanel';
import { ReportLocationEnum } from '../../enums/reportLocationEnum';
import { ToolboxQueryInfo } from '../../types/ViewModel/ToolboxQueryInfo';
import { BerthCall } from '../../types/ViewModel/BerthCall';
import FilterEventsPanel from '../../components/events/filter-events-panel/FilterEventsPanel';
import FilterEvents from '../../components/events/filter-events/FilterEvents';
import { EventTypeFilter } from '../../types/ViewModel/EventTypeFilter';
import SelectedRotationInfo from '../../components/events/SelectedRotationInfo';
import useGetLatestVoyage from '../../api/useGetLatestVoyage';
import { getAllUniqueVoyageNumbers, insertPortCallBasedOnVoyageNumber } from '../../utils/rotationUtils';
import { useSWService } from '../../api/sw/useSWService';
import useApiEndpoints from '../../context/useApiEndpoints';
import { prettifyDateTimeHHmm } from 'odfjell-date-time-utils/dateTimeFormatter';
import useGetEventTypeData from '../../api/useGetEventTypeData';
import useGetBerth from '../../api/useGetBerth';
import { useQueryParamsHandler } from 'odfjell-query-manager';
import { useConnectionStore } from 'src/context/ConnectionContext';
import { useStowageStore } from 'src/context/StowageContext';
import VoyageSelectionPanel from 'src/components/stowage/common/voyageSelectionPanel/VoyageSelectionPanel';
import { VoyageOption } from 'src/types/ViewModel/VoyageOption';
import { generateUnifiedVoyageOptionsList } from '../../utils/voyageSelectionUtils';
import useCheckStowageIntegration from 'src/app/useCheckStowageIntegration';
import useAppFeature from 'src/app/useAppFeature';
import { AppFeatureEnum } from 'src/enums/appFeatureEnum';

const ReportEventsComponent: React.FC = () => {
    const ref = useRef<HTMLInputElement>(null);
    const [voyageOptionsList, setVoyageOptionsList] = useState<VoyageOption[]>([]);
    const [isSortedEventListAsc, setIsSortedEventListAsc] = useState<boolean>(true);
    const [isRightPanelExpanded, setIsRightPanelExpanded] = useState<boolean>(false);
    const [isDeleteEventsEnabled, setIsDeleteEventsEnabled] = useState<boolean>(false);
    const [isDeleteEventsSelected, setIsDeleteEventsSelected] = useState<boolean>(false);
    const [rotationTree, setRotationTree] = useState<Rotation | null>(null);
    const [isPrinterPanelOpen, setIsPrinterPanelOpen] = useState<boolean>(false);
    const [closePrinterPanel, setClosePrinterPanel] = useState<boolean>(false);
    const [deleteEventsToolTipText, setDeleteEventsToolTipText] = useState<string | null>(null);
    const [isEllipsisVerticalButtonSelected, setIsEllipsisVerticalButtonSelected] = useState<boolean>(false);
    const [eventTypeFilterItem, setEventTypeFilterItem] = useState<EventTypeFilter | null>(null);
    const [detailsChecked, setDetailsChecked] = useState<boolean>(false);

    const { getQueryParamValueFromUrl } = useQueryParamsHandler();
    const { newRotationFromCode, newRotationFromCodeExcludeMovedAndDeleted } = RotationFactory();
    const { getExtendedRotation } = useGetRotation();
    const { getEventsForVoyageList } = useGetTankersEventForVoyage();
    const { getLatestVoyage } = useGetLatestVoyage();
    const { selectedVessel } = useVesselStore();
    const { isOffline } = useConnectionStore();
    const {
        fullEventArray,
        selectedEvent,
        setSelectedEvent,
        eventDataForVoyageList,
        setFullEventArray,
        setDeltaEventArray,
        deltaEventArray,
        savedEvent,
        setSavedEvent,
        latestVoyageData,
    } = useEventStore();
    const { selectedEventType, eventTypeDataPort, setToolboxQueryInfo, eventTypeArray } = useEventTypeStore();
    const {
        rotation,
        setUpdatedRotation,
        setCurrentPortCall,
        setNextPortCall,
        updatedRotation,
        selectedNode,
        setSelectedNode,
        selectedStowageVoyages,
        setSelectedStowageVoyages,
        currentPortCall,
    } = useRotationStore();
    const { loadedMasterStowagePlan, activeStowagePlan } = useStowageStore();
    const { deleteEventsForCargoOperation, deleteEventsForBerthCall, deleteEventsForPortCall } = useDeleteTankersEvent();
    const {
        getPortCall,
        getBerthCall,
        getCargoOperation,
        getParentBerthCallFromNode,
        getParentPortCallFromNode,
        getPortCallFromNode,
        getNextPortCall,
        addRemovedRotationNodes,
        getBerthCallFromNode,
        getCargoOperationFromNode,
    } = useRotation();
    const {
        filterOnContextSingleLevelIncludingCargoEvents,
        getFirstPortCallTime,
        getDefaultRotationTree,
        getRotationTreeByVoyages,
        getCurrentPortCall,
    } = useEvent();
    const { getEventTypeFromEvent } = useEventType();
    const { setQueryParamPortCall, setQueryFromSelectedNode, setQueryParamEvent, resetQueryParamPortCall } = queryParamsUtils();
    const { updateRotationNodeFlags, updateRotationNodeTooltipFlags, updateMovedToFlag } = eventMoveUtils();
    const { getEventTypeData } = useGetEventTypeData();
    const { getAllBerths } = useGetBerth();
    const { updateNodeStatus } = eventtypehandler();
    const { createNewEventList } = TankersEventFactory();
    const { role } = useAuthStore();
    const { resetMovedFromClickedFlag } = useRotation();
    const { refreshRequestsContaining } = useSWService();
    const { apiEndpoints } = useApiEndpoints();
    const { queryParamUpdate } = useQueryParamsHandler();
    const { checkLoadedStowageIntegration } = useCheckStowageIntegration();
    const { isFeatureEnabled } = useAppFeature();

    // =============  Use Effects ================

    useEffect(() => {
        if (localStorage.getItem('isSortedEventListAsc')) {
            const lsIsSortedEventListAsc = localStorage.getItem('isSortedEventListAsc');
            if (lsIsSortedEventListAsc === 'true') {
                setIsSortedEventListAsc(true);
            } else {
                setIsSortedEventListAsc(false);
            }
        }
    }, []);

    useEffect(() => {
        if (selectedEventType) {
            setIsRightPanelExpanded(false);
            setEventTypeFilterItem(null);
        }
    }, [selectedEventType]);

    useEffect(() => {
        if (!selectedVessel || checkLoadedStowageIntegration(selectedVessel.imoNumber, loadedMasterStowagePlan)) return;
        getEventTypeData(selectedVessel.imoNumber);
        if (
            !rotation ||
            (checkLoadedStowageIntegration(selectedVessel.imoNumber, loadedMasterStowagePlan) &&
                (loadedMasterStowagePlan.lastUpdatedUtc !== rotation.lastUpdatedUtc || loadedMasterStowagePlan.title !== rotation.stowagePlanName))
        ) {
            getLatestVoyage(selectedVessel.imoNumber);
            getExtendedRotation(selectedVessel.imoNumber);
            if (selectedVessel.hasOrcaWebSimpleMode) {
                getAllBerths();
            }
        }
    }, [selectedVessel, loadedMasterStowagePlan]);

    useEffect(() => {
        if (closePrinterPanel) {
            setClosePrinterPanel(false);
            setIsPrinterPanelOpen(false);
        }
    }, [closePrinterPanel]);

    useEffect(() => {
        if (rotation && (!fullEventArray || fullEventArray.length === 0)) {
            // initially load event data for latest voyage (most recent voyage where there exist any events).
            // also include the voyage before the latest.
            // if no latest voyage can be found (should only happen with vessels without any events, likely new vessel),
            // try to retrieve the 4 latest voyages
            //resetContext();
            const voyageList = new Set<string>();
            if (latestVoyageData?.voyageNumber1) {
                const latestVoyage = latestVoyageData.voyageNumber1.toString();
                if (latestVoyage && latestVoyage.length > 0) voyageList.add(latestVoyageData.voyageNumber1.toString());
            }
            const allUniqueVoyageNumbers = getAllUniqueVoyageNumbers(rotation, latestVoyageData, true);
            const latestUniqueVoyageNumbers = allUniqueVoyageNumbers.slice(0, Math.min(4, allUniqueVoyageNumbers.length));
            const latestVoyageIndex = allUniqueVoyageNumbers.findIndex((x) => x === latestVoyageData?.voyageNumber1?.toString());
            const previousVoyage = latestVoyageIndex > -1 && allUniqueVoyageNumbers?.[latestVoyageIndex + 1];
            if (previousVoyage) {
                voyageList.add(previousVoyage);
            } else {
                latestUniqueVoyageNumbers.forEach(voyageList.add, voyageList);
            }
            includeTurnaroundVoyages(voyageList, rotation);
            getEventsForVoyageList(Array.from(voyageList.values()));
        }
    }, [rotation, latestVoyageData]);

    useEffect(() => {
        if (!currentPortCall || !selectedVessel) return;

        const hasStowageIntegration = isFeatureEnabled({
            featureEnum: AppFeatureEnum.StowageIntegration,
            imoNumber: selectedVessel.imoNumber,
            date: new Date(),
        });
        // Use activeStowagePlan when available (has fresher rotation data from stowage module),
        // fallback to loadedMasterStowagePlan for non-stowage page scenarios
        const stowagePlanForVoyages = activeStowagePlan ?? loadedMasterStowagePlan;
        const voyageOptions = generateUnifiedVoyageOptionsList(
            hasStowageIntegration,
            updatedRotation,
            currentPortCall.voyageNumber1,
            stowagePlanForVoyages,
            selectedVessel
        );
        setVoyageOptionsList(voyageOptions);
    }, [updatedRotation, currentPortCall, loadedMasterStowagePlan, activeStowagePlan, selectedVessel]);

    useEffect(() => {
        if (deltaEventArray && deltaEventArray.length > 0) {
            // Filter delta with respect to events previously retrieved for selected voyages
            const deltaEventsForPreviouslyRetrievedVoyages = deltaEventArray.filter(
                (o) =>
                    eventDataForVoyageList?.imoNumber &&
                    eventDataForVoyageList.imoNumber === selectedVessel.imoNumber &&
                    eventDataForVoyageList.voyageNumbers.some((e) => +e === o.voyageNumber1)
            );
            if (deltaEventsForPreviouslyRetrievedVoyages && deltaEventsForPreviouslyRetrievedVoyages.length > 0) {
                const oldEventsMinusDelta = fullEventArray
                    ? fullEventArray.filter((oldEv) => !deltaEventsForPreviouslyRetrievedVoyages.some((e) => e.eventId === oldEv.eventId))
                    : [];
                const tempEvents = [...oldEventsMinusDelta, ...deltaEventsForPreviouslyRetrievedVoyages.filter((e) => !e.deleted)];
                const updatedEventList = createNewEventList(tempEvents);
                if (savedEvent && updatedEventList.find((event) => event.eventId === savedEvent.eventId)) {
                    setQueryParamEvent(savedEvent.eventId?.toString());
                    setSavedEvent(null);
                }
                setFullEventArray(updatedEventList);
                setDeltaEventArray([]);
            }
            // if deltaEventArray is successfully loaded with no events, set fullEventArray to empty array
        } else if (deltaEventArray && deltaEventArray.length == 0 && !fullEventArray) setFullEventArray([]);
    }, [deltaEventArray]);

    // Re-resolve event types when eventTypeArray becomes available
    // This fixes a race condition where events may load before event type data
    useEffect(() => {
        if (!fullEventArray || fullEventArray.length === 0 || eventTypeArray.length === 0) return;

        // Check if any events have unknown event types (eventType.eventTypeId === -1)
        const hasUnknownEvents = fullEventArray.some((ev) => ev.eventType?.eventTypeId === -1);

        if (hasUnknownEvents) {
            // Re-resolve event types using the now-available eventTypeArray
            // Mutate eventType directly to preserve TankersEvent class instance methods
            fullEventArray.forEach((ev) => {
                if (ev.eventType?.eventTypeId === -1) {
                    ev.eventType = getEventTypeFromEvent(ev);
                }
            });
            // Trigger re-render with a new array reference
            setFullEventArray([...fullEventArray]);
        }
    }, [eventTypeArray]);

    useEffect(() => {
        if (!rotation) return;
        if (fullEventArray) {
            updateRotation(fullEventArray);
        }
    }, [fullEventArray]);

    useEffect(() => {
        if (selectedNode) {
            deleteEventsBtnStatus(selectedNode);
        }
    }, [selectedNode]);

    useEffect(() => {
        if (queryParamUpdate && selectedVessel && !checkLoadedStowageIntegration(selectedVessel.imoNumber, loadedMasterStowagePlan)) {
            if (!rotation) {
                // Refresh (F5) gets the stowage plan
                getExtendedRotation(selectedVessel.imoNumber);
            } else {
                handleQueryPortLog();
            }
        }
    }, [queryParamUpdate]);

    useEffect(() => {
        if (updatedRotation && selectedVessel) {
            handleQueryPortLog();
        }
    }, [updatedRotation]);

    useEffect(() => {
        const checkIfClickedOutside = (event) => {
            if (isPrinterPanelOpen && ref.current && !ref.current.contains(event.target)) {
                setIsPrinterPanelOpen(false);
            }
        };
        document.addEventListener('mousedown', checkIfClickedOutside);
        return () => {
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [isPrinterPanelOpen]);

    useEffect(() => {
        updateRotationTree(updatedRotation, selectedNode);
    }, [selectedStowageVoyages]);

    useEffect(() => {
        if (!selectedVessel) {
            setRotationTree(null);
        }
    }, [selectedVessel]);

    const updateCurrentPortCall = (rot: Rotation) => {
        const currentPortCall = getCurrentPortCall(rot) ?? null;
        setCurrentPortCall(currentPortCall);

        if (currentPortCall) {
            const nextPortCall = getNextPortCall(currentPortCall?.portCallId, rot);
            setNextPortCall(nextPortCall);
        } else {
            setNextPortCall(null);
        }
    };

    const updatePortAndBerthName = (eventArray: TankersEvent[], rotation: Rotation) => {
        rotation.portCallArray.forEach((pc) => {
            if (!pc.name) {
                const pcEv = eventArray.find((ev) => ev.portCallId === pc.portCallId && ev.portName);
                if (pcEv) pc.name = pcEv.portName;
            }
            pc.berthCallArray.forEach((bc) => {
                if (!bc.name) {
                    const bcEv = eventArray.find((ev) => ev.portCallId === pc.portCallId && ev.berthCallId === bc.berthCallId && ev.berthName);
                    if (bcEv) bc.name = bcEv.berthName;
                }
            });
        });
    };

    const updateRotation = (eventArray: TankersEvent[]) => {
        if (rotation) {
            // Add rotation nodes for moved/deleted port calls/berth calls/cargo operations
            const newRot = newRotationFromCodeExcludeMovedAndDeleted(rotation);
            addRemovedRotationNodes(newRot, eventArray);
            updateRotationNodeFlags(eventTypeDataPort, eventArray, newRot);
            updateMovedToFlag(newRot);
            updateRotationNodeTooltipFlags(eventTypeDataPort, eventArray, newRot);
            updateNodeStatus(newRot, eventTypeDataPort);
            updatePortAndBerthName(eventArray, newRot);
            setUpdatedRotation(newRot);
            resetMovedFromClickedFlag(newRot, selectedNode);
            updateCurrentPortCall(newRot);
        }
    };

    const containsMovedDeletedNodes = (portCall: PortCall): boolean => {
        if (portCall.isDeleted || portCall.isMoved) return true;
        let movedDeleted = false;
        portCall.berthCallArray.forEach((bc) => {
            if (bc.isDeleted || bc.isMoved) movedDeleted = true;
            else {
                bc.cargoOperationArray.forEach((co) => {
                    if (co.isDeleted || co.isMoved) movedDeleted = true;
                });
            }
        });
        return movedDeleted;
    };

    const updateAndModifyRotationTree = (rot: Rotation, voyageList: string[]) => {
        const newRot = newRotationFromCode(rot);

        // Add deleted/modified port calls to rotation tree
        updatedRotation?.portCallArray.forEach((pc) => {
            if (containsMovedDeletedNodes(pc)) {
                const pcAlreadyInList = rot.portCallArray.find((o) => o.portCallId === pc.portCallId);
                if (!pcAlreadyInList) {
                    insertPortCallBasedOnVoyageNumber(newRot, pc, voyageList);
                }
            }
        });

        setRotationTree(newRot);
    };

    const updateRotationTree = (rot: Rotation | null, node: IRotationNode | null) => {
        if (selectedStowageVoyages && selectedStowageVoyages.length > 0) {
            const newRot = getRotationTreeByVoyages(selectedStowageVoyages, rot); // Uses UpdatedRotation
            if (newRot) {
                resetMovedFromClickedFlag(newRot, node);
                updateAndModifyRotationTree(newRot, selectedStowageVoyages);
            }
        } else {
            const newRot = getDefaultRotationTree(rot); // Uses UpdatedRotation
            const voyages = newRot?.portCallArray?.map((pc) => pc.voyageNumber1).filter((voy) => !!voy) || [];
            if (newRot) {
                resetMovedFromClickedFlag(newRot, node);
                updateAndModifyRotationTree(newRot, voyages);
            }
        }
    };

    // Include both voyage numbers for turnaround port calls so related events are loaded together
    const includeTurnaroundVoyages = (selectedVoyages: Set<string>, rot: Rotation | null) => {
        if (!rot) return;

        rot.portCallArray.forEach((portCall) => {
            const voyageOne = portCall.voyageNumber1?.toString();
            const turnaroundVoyage = portCall.voyageNumber2?.toString();

            if (!turnaroundVoyage) return;

            const isSelected = (voyageOne && selectedVoyages.has(voyageOne)) || selectedVoyages.has(turnaroundVoyage);
            if (isSelected) {
                if (voyageOne) {
                    selectedVoyages.add(voyageOne);
                }
                selectedVoyages.add(turnaroundVoyage);
            }
        });
    };

    const isSamePortCall = (node: IRotationNode, selNode: IRotationNode) => {
        return node.id === selNode.id && node.reportLocation === selNode.reportLocation;
    };

    const updateSelectedNode = (node: IRotationNode | null) => {
        setSelectedNode(node);
        getFirstPortCallTime(node, fullEventArray);
    };

    const checkAndSetSelectedNode = (node: IRotationNode | null) => {
        if (!selectedNode || !node || selectedNode.type !== node.type) {
            updateSelectedNode(node);
        } else {
            switch (node.type) {
                case RotationTreeEnum.PortCall:
                case RotationTreeEnum.Sea:
                    if (!isSamePortCall(node, selectedNode)) {
                        updateSelectedNode(node);
                    }
                    break;
                case RotationTreeEnum.BerthCall:
                    if (!isSamePortCall(getParentPortCallFromNode(node), getParentPortCallFromNode(selectedNode)) || selectedNode.id !== node.id) {
                        updateSelectedNode(node);
                    }
                    break;
                case RotationTreeEnum.CargoOperation: {
                    const bc1 = getParentBerthCallFromNode(node);
                    const bc2 = getParentBerthCallFromNode(selectedNode);
                    if (
                        node.id !== selectedNode.id ||
                        (bc1 && bc2 && bc1.id !== bc2.id) ||
                        !isSamePortCall(getParentPortCallFromNode(bc1), getParentPortCallFromNode(bc2))
                    ) {
                        updateSelectedNode(node);
                    }
                    break;
                }
            }
        }
    };

    const conditionallyGetEventListForVoyage = (portCall: PortCall) => {
        if (portCall?.voyageNumber1) {
            const voyNrRetrieved =
                eventDataForVoyageList?.imoNumber === selectedVessel?.imoNumber &&
                eventDataForVoyageList.voyageNumbers.find((voyNr) => voyNr === portCall?.voyageNumber1);
            const allUniqueVoyageNumbers = getAllUniqueVoyageNumbers(rotation, latestVoyageData, true);
            const voyageIndex = allUniqueVoyageNumbers.findIndex((x) => x === portCall.voyageNumber1);
            const previousVoyage = voyageIndex > -1 && allUniqueVoyageNumbers?.[voyageIndex + 1];
            const voyages: string[] = [];
            // if selected voyage does not already exist in event data
            if (!voyNrRetrieved) voyages.push(portCall.voyageNumber1);

            // For turnaround ports (port clusters), also fetch voyageNumber2 if it exists and differs from voyageNumber1
            if (portCall.voyageNumber2 && portCall.voyageNumber2 !== portCall.voyageNumber1) {
                const voy2Retrieved =
                    eventDataForVoyageList?.imoNumber === selectedVessel?.imoNumber &&
                    eventDataForVoyageList.voyageNumbers.find((voyNr) => voyNr === portCall.voyageNumber2);
                if (!voy2Retrieved) voyages.push(portCall.voyageNumber2);
            }

            // add previous voyage to request if it exists in voyagelist, but has not already been requested,
            // this is because the first portcall in a voyage might share events with previous voyage
            const prevVoyNrRetrieved =
                previousVoyage &&
                eventDataForVoyageList?.imoNumber === selectedVessel?.imoNumber &&
                eventDataForVoyageList.voyageNumbers.find((voyNr) => voyNr === previousVoyage);
            if (previousVoyage && !prevVoyNrRetrieved) voyages.push(previousVoyage);

            if (voyages.length > 0) getEventsForVoyageList(voyages);
        }
    };

    const handleQueryPortLog = () => {
        const portCallId = getQueryParamValueFromUrl('portCallId');
        const reportLocation = getQueryParamValueFromUrl('reportLocation');
        const berthCallId = getQueryParamValueFromUrl('berthCallId');
        const cargoOperationId = getQueryParamValueFromUrl('cargoOperationId');
        const eventId = getQueryParamValueFromUrl('eventId');
        const eventTypeId = getQueryParamValueFromUrl('eventTypeId');
        const seqNr = getQueryParamValueFromUrl('seqNr');

        let isQuerySet = false;
        if (portCallId && reportLocation) {
            const pc = getPortCall(updatedRotation, +portCallId, +reportLocation);

            if (pc) {
                let node: IRotationNode = pc;
                if (berthCallId) {
                    const bc = getBerthCall(updatedRotation, +portCallId, +berthCallId);

                    if (bc) {
                        node = bc;
                        // For port clusters, use the berth call's actual port call for voyage-related operations
                        const effectivePortCall = bc.portCall ?? pc;
                        if (cargoOperationId) {
                            const co = getCargoOperation(updatedRotation, effectivePortCall.portCallId, +berthCallId, +cargoOperationId);
                            if (co) {
                                node = co;
                                checkAndSetSelectedNode(co);
                                handleQueryContext(co, eventId, eventTypeId, seqNr);
                            } else {
                                setQueryFromSelectedNode(bc);
                                isQuerySet = true;
                            }
                        } else {
                            checkAndSetSelectedNode(bc);
                            handleQueryContext(bc, eventId, eventTypeId, seqNr);
                        }
                        // Use the effective port call (which may differ for port clusters)
                        updateSelectedRotations(effectivePortCall);
                        if (!isQuerySet) {
                            conditionallyGetEventListForVoyage(effectivePortCall);
                            updateRotationTree(updatedRotation, node);
                        }
                    } else {
                        setQueryFromSelectedNode(pc);
                        isQuerySet = true;
                        updateSelectedRotations(pc);
                        updateRotationTree(updatedRotation, pc);
                    }
                } else {
                    checkAndSetSelectedNode(pc);
                    handleQueryContext(pc, eventId, eventTypeId, seqNr);
                    updateSelectedRotations(pc);
                    if (!isQuerySet) {
                        conditionallyGetEventListForVoyage(pc);
                        updateRotationTree(updatedRotation, pc);
                    }
                }
            } else {
                setSelectedNode(null);
                setQueryFromSelectedNode(null);
                updateRotationTree(updatedRotation, null);
            }
        } else if (selectedNode) {
            // Click 'Report events' in left side panel
            setQueryFromSelectedNode(selectedNode);
        } else if (currentPortCall && (!selectedStowageVoyages || selectedStowageVoyages.length === 0)) {
            setQueryParamPortCall(currentPortCall.portCallId?.toString(), currentPortCall?.reportLocation);
        }
    };

    const handleQueryContext = (rotationNode: IRotationNode, eventId: string | null, eventTypeId: string | null, seqNr: string | null) => {
        if (eventId) handleQueryEventId(rotationNode, eventId);
        else if (eventTypeId) handleQueryToolboxIds(eventTypeId, seqNr);
    };

    const handleQueryEventId = (rotationNode: IRotationNode, eventId: string) => {
        if (!fullEventArray) return;
        const eventList = filterOnContextSingleLevelIncludingCargoEvents(rotationNode, fullEventArray);
        if (eventList && eventList.length > 0) {
            const ev = eventList.find((o) => o.eventId?.toLocaleLowerCase() === eventId.toLocaleLowerCase());
            if (ev) {
                setSelectedEvent(ev);
            }
        }
    };

    const handleQueryToolboxIds = (eventTypeId: string, seqNr: string | null) => {
        if (eventTypeId) {
            setToolboxQueryInfo(new ToolboxQueryInfo(eventTypeId, seqNr));
        }
    };

    const updateSelectedRotations = (portCall: PortCall) => {
        let _selectedVoyages: string[] = [];
        const defRot = getDefaultRotationTree(updatedRotation);

        if (selectedStowageVoyages && selectedStowageVoyages.length > 0) {
            let isVoyageInSelectedRotations;

            if (
                portCall.voyageNumber2 &&
                (selectedStowageVoyages.includes(portCall.voyageNumber1) || selectedStowageVoyages.includes(portCall.voyageNumber2))
            ) {
                isVoyageInSelectedRotations = true;
            } else {
                isVoyageInSelectedRotations = selectedStowageVoyages.includes(portCall.voyageNumber1);
            }

            if (!isVoyageInSelectedRotations) {
                _selectedVoyages.push(portCall.voyageNumber1);
            } else {
                _selectedVoyages = [...selectedStowageVoyages];
            }
        } else if (
            defRot &&
            defRot.portCallArray.length > 0 &&
            (defRot.portCallArray.find((o) => o.portCallId === +portCall.portCallId) || containsMovedDeletedNodes(portCall))
        ) {
            // When the default rotation tree has portcalls, gather their voyage numbers
            if (defRot) {
                const uniqueVoyages = new Set<string>();

                defRot.portCallArray.forEach((portCall) => {
                    if (portCall.voyageNumber1) {
                        uniqueVoyages.add(portCall.voyageNumber1);
                    }
                });

                // Add all unique voyages to the selected voyages
                _selectedVoyages = Array.from(uniqueVoyages);
            }
        } else {
            _selectedVoyages.push(portCall.voyageNumber1);
        }

        if (_selectedVoyages && _selectedVoyages.length > 0) {
            setSelectedStowageVoyages([..._selectedVoyages].sort());
        } else {
            setSelectedStowageVoyages([]);
        }
    };

    const toggleSortEventsList = () => {
        if (isSortedEventListAsc) {
            setIsSortedEventListAsc(false);
            localStorage.setItem('isSortedEventListAsc', JSON.stringify(false));
        } else {
            setIsSortedEventListAsc(true);
            localStorage.setItem('isSortedEventListAsc', JSON.stringify(true));
        }
    };

    const toggleExpandRightPanel = () => {
        setIsRightPanelExpanded(!isRightPanelExpanded);
    };

    const toggleDeleteCargoOpsEvents = () => {
        setIsDeleteEventsSelected(!isDeleteEventsSelected);
    };

    const isTrashButtonVisible = () => {
        if (
            selectedNode?.type === RotationTreeEnum.CargoOperation ||
            selectedNode?.type === RotationTreeEnum.BerthCall ||
            selectedNode?.type === RotationTreeEnum.PortCall
        ) {
            return !isDeleteEventsSelected;
        }
        return false;
    };

    const cancelDeleteEvents = () => {
        setIsDeleteEventsSelected(false);
    };

    const deleteAllEvents = () => {
        if (selectedNode && selectedVessel) {
            const pc = getPortCallFromNode(selectedNode);
            setIsDeleteEventsSelected(false);
            let deleteEventPromise = null;
            switch (selectedNode.type) {
                case RotationTreeEnum.PortCall:
                    deleteEventPromise = deleteEventsForPortCall(selectedVessel.imoNumber, selectedNode.id, false);
                    break;
                case RotationTreeEnum.BerthCall:
                    deleteEventPromise = deleteEventsForBerthCall(selectedVessel.imoNumber, pc?.portCallId, selectedNode.id, false);
                    break;
                case RotationTreeEnum.CargoOperation: {
                    const co = getCargoOperationFromNode(selectedNode);
                    if (co && co.berthCall) {
                        deleteEventPromise = deleteEventsForCargoOperation(
                            selectedVessel.imoNumber,
                            pc?.portCallId,
                            co.berthCall.id,
                            selectedNode.id
                        );
                    }
                    break;
                }
            }

            deleteEventPromise.then((response) => {
                if (response) {
                    const params = '?voyageNumber1=' + pc.voyageNumber1 + '&voyageNumber2=&imoNumber=' + selectedVessel.imoNumber;
                    refreshRequestsContaining([apiEndpoints['getTankersEventDataDeltaForVoyage'].url], params);
                }
            });
        }
    };

    const hasReaderPermissionOnly = () => {
        return role && !role.isWriter;
    };

    const onPrintCancel = () => {
        setClosePrinterPanel(true);
    };

    const onPrintOk = () => {
        setIsPrinterPanelOpen(false);
    };

    const getPrinterPanel = () => {
        if (isPrinterPanelOpen) {
            return <PrinterPanel onCancel={onPrintCancel} onPrint={onPrintOk} isOpen={isPrinterPanelOpen} />;
        }
        return null;
    };

    const onFilterEventsCancel = () => {
        setClosePrinterPanel(true);
    };

    const onFilterEventsSelected = (filterEventsItem: EventTypeFilter) => {
        setEventTypeFilterItem(filterEventsItem);
        setIsEllipsisVerticalButtonSelected(false);
    };

    const getFilterEventsPanel = () => {
        if (isEllipsisVerticalButtonSelected) {
            return (
                <FilterEventsPanel onCancel={onFilterEventsCancel} onSelected={onFilterEventsSelected} isOpen={isEllipsisVerticalButtonSelected} />
            );
        }
        return null;
    };

    const handlePrintEvent = () => {
        setIsPrinterPanelOpen(!isPrinterPanelOpen);
    };

    const handleEllipsisVertical = () => {
        setIsEllipsisVerticalButtonSelected(!isEllipsisVerticalButtonSelected);
    };

    const hasEvents = (): boolean => {
        if (selectedNode && fullEventArray && fullEventArray.length > 0) {
            const pc = getPortCallFromNode(selectedNode);
            if (pc) {
                const evList = fullEventArray.filter((o) => !o.deleted && o.portCallId === pc.portCallId);
                return evList && evList.length > 0;
            }
        }
        return false;
    };

    const getPrintTooltip = (): string => {
        if (hasEvents()) {
            return 'Click to generate cargo document';
        }
        return 'No events to print';
    };

    const canDeleteEventsForBerthCall = (bc: BerthCall | null): boolean => {
        if (bc && (bc.isDeleted || bc.isMoved)) {
            return !bc.cargoOperationArray || bc.cargoOperationArray.length === 0;
        }
        return false;
    };

    const canDeleteEventsForPortCall = (pc: PortCall | null): boolean => {
        if (pc && (pc.isDeleted || pc.isMoved)) {
            return !pc.berthCallArray || pc.berthCallArray.length === 0;
        }
        return false;
    };

    const deleteEventsBtnStatus = (selectedNode: IRotationNode) => {
        switch (selectedNode.type) {
            case RotationTreeEnum.Sea:
                break;
            case RotationTreeEnum.PortCall: {
                const pc = getPortCallFromNode(selectedNode);
                if (canDeleteEventsForPortCall(pc)) {
                    setIsDeleteEventsEnabled(true);
                    setDeleteEventsToolTipText('Delete all events for this port call?');
                } else {
                    setIsDeleteEventsEnabled(false);
                    setDeleteEventsToolTipText('Can only delete all events for moved/deleted port calls and with no berth calls');
                }
                break;
            }
            case RotationTreeEnum.BerthCall: {
                const bc = getBerthCallFromNode(selectedNode);
                if (canDeleteEventsForBerthCall(bc)) {
                    setIsDeleteEventsEnabled(true);
                    setDeleteEventsToolTipText('Delete all events for this berth call?');
                } else {
                    setIsDeleteEventsEnabled(false);
                    setDeleteEventsToolTipText('Can only delete all events for moved/deleted berth calls and with no cargo operations');
                }
                break;
            }
            case RotationTreeEnum.CargoOperation: {
                const co = getCargoOperationFromNode(selectedNode);
                if (co && (co.isDeleted || co.isMoved)) {
                    setIsDeleteEventsEnabled(true);
                    setDeleteEventsToolTipText('Delete all events for this cargo operation?');
                } else {
                    setIsDeleteEventsEnabled(false);
                    setDeleteEventsToolTipText('Can only delete all events for moved/deleted cargo operations');
                }
                break;
            }
        }
    };

    const deleteEventsTooltipText = () => {
        if (deleteEventsToolTipText) {
            return deleteEventsToolTipText;
        }
        return undefined;
    };

    const deleteEventsLeadText = (): string => {
        if (selectedNode) {
            switch (selectedNode.type) {
                case RotationTreeEnum.PortCall:
                    return 'Delete all events for port call?';
                case RotationTreeEnum.BerthCall:
                    return 'Delete all events for berth call?';
                case RotationTreeEnum.CargoOperation:
                    return 'Delete all events for cargo operation?';
            }
        }
        return '';
    };

    const showPrintButton = (): boolean => {
        if (selectedVessel?.hasOrcaWebSimpleMode || (selectedNode && selectedNode.reportLocation === ReportLocationEnum.Sea) || isOffline)
            return false;
        return true;
    };

    const detailsChkChange = () => {
        setDetailsChecked(!detailsChecked);
    };

    const detailsCheckbox = () => {
        if (!eventTypeFilterItem) {
            return (
                <DetailsCheckboxWrapper>
                    <DetailsText>Details</DetailsText>
                    <input
                        type="checkbox"
                        name={'detailsCheckbox'}
                        value={'true'}
                        onChange={detailsChkChange}
                        checked={detailsChecked}
                        autoComplete="off"
                    ></input>
                </DetailsCheckboxWrapper>
            );
        }
        return null;
    };

    const trashButton = () => {
        if (isTrashButtonVisible() && !hasReaderPermissionOnly() && !eventTypeFilterItem) {
            return (
                <TrashButton disabled={!isDeleteEventsEnabled} isSelected={isDeleteEventsSelected} onClick={toggleDeleteCargoOpsEvents}>
                    <FontAwesomeIcon title={deleteEventsTooltipText()} icon="trash" />
                </TrashButton>
            );
        }
        return null;
    };

    const printButton = () => {
        if (showPrintButton() && !eventTypeFilterItem) {
            return (
                <PrinterButton isSelected={true} disabled={!hasEvents()} onClick={handlePrintEvent}>
                    <FontAwesomeIcon icon="print" title={getPrintTooltip()} />
                </PrinterButton>
            );
        }
        return null;
    };

    const sortButton = () => {
        if (eventTypeFilterItem) return null;
        if (isSortedEventListAsc) {
            return (
                <SortButton isSelected={isSortedEventListAsc} onClick={toggleSortEventsList}>
                    <FontAwesomeIcon title="Click to sort by date in ascending order" icon="sort-amount-up" />
                </SortButton>
            );
        }
        return (
            <SortButton isSelected={isSortedEventListAsc} onClick={toggleSortEventsList}>
                <FontAwesomeIcon title="Click to sort by date in descending order" icon="sort-amount-down" />
            </SortButton>
        );
    };

    const ellipsisVerticalButton = () => {
        if (eventTypeDataPort) {
            if (!eventTypeDataPort.eventTypeFilterList || eventTypeDataPort.eventTypeFilterList.length === 0) {
                return null;
            }
        }
        if (eventTypeFilterItem) {
            return null;
        }
        return (
            <EllipsisVerticalButton isSelected={true} onClick={handleEllipsisVertical}>
                <FontAwesomeIcon icon="ellipsis-v" title="Filter events" />
            </EllipsisVerticalButton>
        );
    };

    const expandPanelButton = () => {
        if (eventTypeFilterItem) return null;
        return (
            <ExpandPanelButton top={'50%'} onClick={toggleExpandRightPanel}>
                {!isRightPanelExpanded && <FontAwesomeIcon icon="chevron-left" />}
                {isRightPanelExpanded && <FontAwesomeIcon icon="chevron-right" />}
            </ExpandPanelButton>
        );
    };

    const exitEventsFilter = () => {
        setEventTypeFilterItem(null);
    };

    const isViewingCargoLevelEvents = (): boolean => {
        if (!selectedNode) return false;
        return selectedNode.type === RotationTreeEnum.CargoOperation;
    };

    const getTitleText = () => {
        if (eventTypeFilterItem) return <h3>Filtered events ({eventTypeFilterItem.filterHeading})</h3>;
        return <h3>Reported events</h3>;
    };

    const getExitButton = () => {
        if (eventTypeFilterItem)
            return (
                <ExitButton onClick={exitEventsFilter}>
                    <FontAwesomeIcon icon="times" />
                </ExitButton>
            );
        return null;
    };

    const getTitle = () => {
        return (
            <TitleOuterWrapper>
                {getTitleText()}
                <LastUpdated>Last update: {prettifyDateTimeHHmm(updatedRotation?.lastUpdatedUtc)}</LastUpdated>
            </TitleOuterWrapper>
        );
    };

    const deleteEvent = () => {
        return (
            <DeleteEventsWrapper>
                <DeleteTextWrapper>
                    <h3>{deleteEventsLeadText()}</h3>
                </DeleteTextWrapper>
                <DeleteButtonsWrapper>
                    <PlainTextButton className="cancel-btn" disabled={false} isSelected={true} onClick={cancelDeleteEvents}>
                        Cancel
                    </PlainTextButton>
                    <PlainTextButton className="delete-btn" disabled={false} isSelected={true} onClick={deleteAllEvents}>
                        Delete
                    </PlainTextButton>
                </DeleteButtonsWrapper>
            </DeleteEventsWrapper>
        );
    };

    const eventsList = () => {
        if (eventTypeFilterItem) return <FilterEvents eventTypeFilter={eventTypeFilterItem}></FilterEvents>;
        return <ReportedEventsList sortAsc={isSortedEventListAsc} showDetails={detailsChecked} />;
    };

    const clearFiltersCallback = () => {
        resetQueryParamPortCall();
        setSelectedNode(null);
    };

    const createQueryParamForVoyage = (selectedVoyages: string[], selectedVoyageNumber: string, voyageNrOn: boolean) => {
        if (!selectedVoyages || selectedVoyages.length === 0) {
            resetQueryParamPortCall();
            setSelectedNode(null);
        } else {
            if (voyageNrOn) {
                const pc = updatedRotation?.portCallArray.find((o) => o.voyageNumber1 === selectedVoyageNumber);
                if (pc) {
                    setQueryFromSelectedNode(pc);
                }
            } else {
                const pc = updatedRotation?.portCallArray.find((o) => o.voyageNumber1 === selectedVoyages[0]);
                if (pc) {
                    setQueryFromSelectedNode(pc);
                }
            }
        }
    };

    const onSelectVoyageCallback = (selectedVoyageNumbers: string[], selectedVoyageNumber: string, isVoyageNumberOn: boolean) => {
        createQueryParamForVoyage(selectedVoyageNumbers, selectedVoyageNumber, isVoyageNumberOn);
    };

    return (
        <PageContentWrapper>
            <LeftContentWrapper>
                <LeftTopWrapper>
                    <VoyageSelectionPanel
                        voyageOptionsList={voyageOptionsList}
                        onClearFiltersCallback={clearFiltersCallback}
                        onSelectVoyageCallback={onSelectVoyageCallback}
                    />
                    <RightWrapper>
                        <ReportingContextInfo />
                        <SelectedRotationInfo />
                    </RightWrapper>
                </LeftTopWrapper>

                <LeftBottomWrapper>
                    {rotationTree && <RotationTree rotationTree={rotationTree} />}
                    <EventToolboxComponent twoCol={true} />
                </LeftBottomWrapper>
            </LeftContentWrapper>

            <EventWrapper className={eventTypeFilterItem || isRightPanelExpanded ? 'is-shrunk' : ''}>
                {selectedEventType && fullEventArray && (
                    <EventInputWrapper>
                        <EventInputComponent tankersEvent={null} eventType={selectedEventType}></EventInputComponent>
                    </EventInputWrapper>
                )}
                {selectedEvent && !selectedEventType && fullEventArray && (
                    <EventInputWrapper>
                        <EventInputComponent tankersEvent={selectedEvent} eventType={null}></EventInputComponent>
                    </EventInputWrapper>
                )}
            </EventWrapper>

            <RightContentWrapper className={eventTypeFilterItem || isRightPanelExpanded ? 'is-expanded' : ''}>
                <HeadingOuterWrapper>
                    <HeadingWrapper>
                        <LeftHeadingWrapper>
                            {getExitButton()}
                            {getTitle()}
                        </LeftHeadingWrapper>
                        <RightHeadingWrapper>
                            {detailsCheckbox()}
                            {trashButton()}
                            {isViewingCargoLevelEvents() && <RetroactiveCargoModeToggle compact={true} />}
                            {printButton()}
                            {sortButton()}
                            {ellipsisVerticalButton()}
                        </RightHeadingWrapper>
                    </HeadingWrapper>
                    {getPrinterPanel()}
                    {getFilterEventsPanel()}
                    {isDeleteEventsSelected && !hasReaderPermissionOnly() && deleteEvent()}
                </HeadingOuterWrapper>
                {expandPanelButton()}
                {eventsList()}
            </RightContentWrapper>
        </PageContentWrapper>
    );
};
export default ReportEventsComponent;
